import React, {Component, Fragment} from 'react';
import SimplePopover from '../../SimplePopover';
import ItemAgendamentoAlunosTurma from './ItemAgendamentoAlunosTurma';

class ItemAgendamento extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    async componentDidMount() {
       // console.log('this props ', this.props)

    }

    render() {
        const { item } = this.props
        return (<tr key={`item-simulado-${item.idEventPracticeTest}`} >

            <td className="edb-center edb-block-mobile">
                <div className="edb-hide-medium edb-hide-large  edb-margin-small-bottom edb-left edb-margin-small-right">
                    <i className="far fa-calendar-alt edb-margin-small-right"></i>
                    <span className="edb-text-bold"> Período</span>
                </div>
                {/* Sinalizador verde caso simulado em andamento */}
                <div className="edb-left-align">

                    {item.emAndamento && <SimplePopover content={<div>
                        <strong>Em andamento</strong>
                        <div>Alguns recursos estão desabilitados.</div>
                    </div>}>
                        <i className="fas fa-circle adap-text-green edb-margin-small-right"></i>
                    </SimplePopover>}

                    {item.dtStartEvent} a {item.dtEndEvent}
                </div>
            </td>
            <td className="edb-center  edb-block-mobile">
                <div className="edb-hide-medium edb-hide-large  edb-margin-small-bottom edb-left edb-margin-small-right">
                    <i className="far fa-chart-bar edb-margin-small-right"></i>
                    <span className="edb-text-bold"> Realizados</span>
                </div>
                <div className="edb-left-align">
                    {item.nuPracticeTestDone}/{item.nuPracticeTestTotal}
                </div>
            </td>
            <td className="edb-center  edb-block-mobile">
                <div className="edb-hide-medium edb-hide-large  edb-margin-small-bottom edb-left edb-margin-small-right">
                    <i className="fas fa-users edb-margin-small-right"></i>
                    <span className="edb-text-bold"> {item.EventToClass === 1?'Turmas':'Alunos'}</span>
                </div>
                <div className="edb-left-align edb-cell">
                    {(item.turmas || []).map((turma, index) =>
                        <Fragment>
                        {/* {console.log(item)} */}
                            {item.EventToClass === 1 &&
                                <SimplePopover rightAlign='true' key={`title_${item.idEvent}_${turma.idEntityClass}_${index}`} content="Carregando..." onLoad={_ => this.props.getPopoverAlunosDaTurma(item.idEvent, turma.idEntityClass)}>
                                    <span className="edb-btn-link adap-text-darkergray edb-left-align">{turma.txClassName}</span>
                                </SimplePopover>
                            }
                            {item.EventToClass === 0 &&
                                <ItemAgendamentoAlunosTurma key={`itemturma_${item.idEvent}_${turma.idEntityClass}_${index}`} turma={turma}
                                idsAccountPracticeTestDone={item.idsAccountPracticeTestDone}
                                event={item.idEvent} getAlunosDoAgendamento={this.props.getAlunosDoAgendamento}
                                onEditarAgendamentoAlunos={this.props.onEditarAgendamentoAlunos}

                                />

                                //  this.getAlunosDoAgendamento(this, item.idEvent, turma.idEntityClass)

                            }
                        </Fragment>
                    )}

                </div>
            </td>

            {!this.props.isProfessor && <td className="edb-center  edb-block-mobile">
                <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                    <i className="far fa-clock edb-margin-small-right"></i>
                    <span className="edb-text-bold"> Agenda</span>
                </div>
                <div className="edb-left-align">

                    {!!item.reagendarAtivo  && <div className="edb-btn-link adap-text-green edb-text-bold"
                    onClick={_ => this.props.onReagendar(item.idEventPracticeTest, item.idEvent, this.alunosChecked)}>Reagendar</div>}

                    {!!item.editarTurma && <span className="edb-btn-link adap-text-green edb-text-bold"
                    onClick={_ => this.props.onAgendar(item.idEventPracticeTest, item.idEvent, 'editar')}>Editar</span>}

                    {!!item.excluirTurma && <span className="edb-btn-link adap-text-green edb-text-bold"
                     onClick={ev => this.props.onExcluir(item.idEventPracticeTest, item.idEvent)}>Excluir</span>}

                    {!!item.editarAlunos && <span className="edb-btn-link adap-text-green edb-text-bold"
                    onClick={_ => this.props.onAgendar(item.idEventPracticeTest, item.idEvent, 'editar')}>Editar</span>}

                    {!!item.excluirAlunos && <span className="edb-btn-link adap-text-green edb-text-bold"
                     onClick={ev => this.props.onExcluir(item.idEventPracticeTest, item.idEvent)}>Excluir</span>}

                </div>
            </td>}


        </tr>);
    }
}

export default ItemAgendamento;
